import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=64d8709e&scoped=true&style=position%3A%20relative%3B&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Login.vue?vue&type=style&index=1&id=64d8709e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8709e",
  null
  
)

export default component.exports